import Vue from 'vue'
import Auth from './Auth'
export default {
  url: Auth.getUrl('curl'),
  get (url) {
    return Vue.http.get(this.url + '/get?url=' + url)
  }
}



// WEBPACK FOOTER //
// ./src/services/Curl.js